import { motion } from "framer-motion";

const FloretWalkThrough = () => {
  return (
    <section className="bg-white py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center text-center"
        >
          {/* Framed Video */}
          <div className="relative w-full max-w-7xl mx-auto h-[60vh] sm:h-[70vh] lg:h-[82vh] overflow-hidden rounded-2xl shadow-2xl bg-transparent">
  <div className="absolute inset-0">
    <iframe
      src="https://www.youtube.com/embed/DiNoPaKUESE?autoplay=1&mute=1&loop=1&playlist=DiNoPaKUESE&controls=0&rel=0&modestbranding=1&playsinline=1&disablekb=1"
      title="Floret Town Walkthrough Video"
      allow="autoplay; fullscreen; encrypted-media"
      allowFullScreen
      className="
        absolute
        top-1/2 left-1/2
        w-[177.78vh]
        h-[100vw]
        min-w-full
        min-h-full
        -translate-x-1/2
        -translate-y-1/2
        pointer-events-none
      "
    />
  </div>
</div>


          {/* Caption */}
          <p className="mt-6 text-sm sm:text-base text-gray-600 max-w-2xl">
            Watch the complete villa walkthrough and explore the lifestyle at Floret Town.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FloretWalkThrough;
